import { render, staticRenderFns } from "./PtrLoading.vue?vue&type=template&id=51118b8b&scoped=true"
var script = {}
import style0 from "./PtrLoading.vue?vue&type=style&index=0&id=51118b8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51118b8b",
  null
  
)

export default component.exports